import auth from '../services/auth';
import history from '../history';




export default function getchecaToken() {
        const chave = localStorage.getItem('lukos-token');

        auth.get('/users/checktoken', {
            headers: {
                token: chave
            }
        })
        .then(res => {
            localStorage.setItem('lukos-token', res.data.token);
        })
        .catch(error => {
            localStorage.removeItem('lukos-token');
            history.push('/login');
        })                  


        const isLogged = !!localStorage.getItem('lukos-token');

        if (isLogged === false) {
          history.push('/login');
        } 

        return (
            ''
        )

}


